import {useItemsDashboard} from '@kit';

import React from 'react';

import {Layout} from '../../components/layout';
import {useFilters} from '../../components/filters';
import {NotFoundSeo, SectionSeo} from '../../lib/seo';
import {getApolloError, cls, normalizeRuStr} from '../../components/utils';
import {Item, useItemsQuery} from '../../generated/types';
import {useRoute} from '../../lib/routes';
import {ItemView} from './view';
import {getAllTitles, getItemBaseType, getItemRarity} from '../../components/render-helpers';
import {ItemFilters, itemFilters, toItemFilterInput} from './filters';

import css from '@kit/sidebar/dashboard.module.css';
import pageCss from '../../components/common.module.css';

type Props = {};

export const ItemsPage: React.FC<Props> = () => {
	const filters = useFilters(itemFilters);

	const router = useRoute();
	const query = router?.query || {};
	const variantId = query.variantId as string | undefined;

	const {data, loading, error} = useItemsQuery({
		ssr: true,
		variables: {filters: toItemFilterInput(filters.values)},
	});

	const {selectedId, selected, showView, handleBack, Sidebar, notFound} = useItemsDashboard({
		items: data?.items || [],
		id: query.id as string,
		loading,
		route: 'item',
		baseRoute: 'items',
		sidebarHeader: (item) => item.title,
		sidebarSecondary: (item) => {
			const rarity = getItemRarity(item as Item);
			return `${getItemBaseType(item as Item)}${rarity ? ` • ${rarity}` : ''}`;
		},
		filterFn: (item, str) => {
			const names = getAllTitles(item as Item);
			return names.filter(Boolean).some((name) => normalizeRuStr(name).includes(normalizeRuStr(str)));
		},
		onOpenFilters: filters.toggle,
		isFiltersSet: filters.isSet,
	});

	const title = showView && selected ? selected.title : 'Предметы';

	return (
		<Layout handleBack={selected && handleBack}>
			{!selectedId && <SectionSeo section="items" />}
			{notFound && <NotFoundSeo />}
			<ItemFilters filters={filters} />
			<div className={css.dashboard}>
				{error ? (
					<div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>
				) : (
					<div className={cls(css.dashboardWrapper, showView && css.showView)}>
						<div className={css.sidebar}>{Sidebar}</div>
						<div className={css.view}>
							{selectedId && showView ? (
								<ItemView baseId={selectedId} variantId={variantId} title={title} />
							) : (
								<div className={pageCss.fullSizeBlock}>Выберите предмет</div>
							)}
						</div>
					</div>
				)}
			</div>
		</Layout>
	);
};
